import { CSSTransition } from 'react-transition-group'
import {useSelector} from 'react-redux'
import Header from '../../features/header/header'
import Price from '../../features/price/price'
import About from '../../features/about/about'
import HowWorks from '../../features/how-works/how-works'
import Tickets from '../../features/tickets/tickets'
import Contacts from '../../features/contacts/contacts'
import Reviews from '../../features/reviews/reviews'
import Messengers from '../../features/messengers/messengers'
import Footer from '../../features/footer/footer'
import MobileMenu from '../../features/mobile-menu/mobile-menu'

import { menuOpenedSelector } from '../../models/menu/selectors'

import c from './assets/sass/page.module.scss'

const MainPage = () => {
    const menuOpened = useSelector(menuOpenedSelector)

    return (
        <div className={c.component}>
            <CSSTransition
                in={menuOpened}
                timeout={300}
                classNames={{
                    enter: c.enter,
                    enterActive: c.enterActive,
                    exit: c.exit,
                    exitActive: c.exitActive,
                }}
                unmountOnExit
            >
                <MobileMenu />
            </CSSTransition>
            <Header />
            <Price />
            <About />
            <HowWorks />
            <Tickets />
            <Contacts />
            <Reviews />
            <Messengers />
            <Footer />
        </div>
    )
}

export default MainPage
